import type { CSSProperties } from "react"

/** Exact Figma glyph alpha, recolored with the active navigation state. */
export const RedesignIcon = ({ name }: { readonly name: "home" | "shop" | "account" | "notice" }) => <span aria-hidden="true" className={`redesign-icon redesign-icon-${name}`} style={{ "--redesign-icon-source": `url(/assets/cashhub/redesign/nav-${name}.svg)` } as CSSProperties} />
